import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "../style/Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer-container">
      <div className="footer-main">
        <div className="footer-content">
          <h2 className="footer-title">Contact Us</h2>
          <div className="contact-info">
            <p>
              <FaPhoneAlt className="footer-icon phone-icon" />
              <a href="tel:+919626699221">+91 9626699221</a>
            </p>
            <p>
              <FaPhoneAlt className="footer-icon phone-icon" />
              <a href="tel:+919626011556">+91 9626011556</a>
            </p>
            <p>
              <FaEnvelope className="footer-icon email-icon" />
              <a href="mailto:svp1998.cbe@gmail.com">svp1998.cbe@gmail.com</a>
            </p>
            <p>
              <FaMapMarkerAlt className="footer-icon location-icon" />
              7/55-2, Balaji Nagar, Keeranatham (PO), Coimbatore - 641035.
            </p>
          </div>
        </div>

        <div className="footer-map">
          <iframe
            title="Company Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.185746589452!2d77.0139172!3d11.0995302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8f9e4052ac177%3A0xee5253baf43788df!2ssri%20vigneswara%20packs!5e0!3m2!1sen!2sin!4v1755965447495!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Sri Vigneswara Packs. All Rights Reserved.</p>
        <div className="footer-links">
          <a href="/terms">Terms & Conditions</a>
          <a href="/privacy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
